import React, { Component } from 'react';
import { styles as s, format as f } from '../stylesheet';
import v from 'vudu';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setModal } from 'state/actions/viewActions';
import get from 'utils/get';

const localClasses = v({
  modalParent: {
    '@composes': [s.z2]
  },
  modalParentActive: {
    '@composes': [s.fixed, s.t0, s.l0],
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)'
  },
  modal: {
    borderRadius: '6px'
  },
  modalActive: {
    '@composes': [s.relative],
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    height: '70%',
    top: '15%'
  }
});

class Modal extends Component {
  didClickModal = event => {
    if (event.target === this.parentRef) {
      this.props.actions.setModal({ body: null });
    }
  }
  render() {
    const { body } = this.props;
    const consideredActive = !!body;
    let parentClasses = f(localClasses.modalParent);
    if (consideredActive) parentClasses = f(parentClasses, localClasses.modalParentActive)
    let modalClasses = f(localClasses.modal);
    if (consideredActive) modalClasses = f(modalClasses, localClasses.modalActive)
    return (
      <div className={parentClasses} onClick={this.didClickModal} ref={r => this.parentRef = r}>
        <div className={modalClasses}>{body}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    body: get(state, 'viewState.modal.body')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setModal
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal.js